import React, { useState, useEffect } from 'react';
import { BringzzText, BringzzIcon } from "@bringzz/components";
import classNames from 'classnames';
import useRequest from 'hooks/useRequest';
import { useTranslation } from 'react-i18next';
import { useNavigation } from 'context/NavigationContext';

const ITEM_HEIGHT = 48; // h-12 = 3rem = 48px

const ProductCategories = () => {
    const { t } = useTranslation();
    const { navigate } = useNavigation();
    const [categories, setCategories] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);
    const { sendRequest, loading } = useRequest();

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await sendRequest({
                    method: 'GET',
                    url: '/module/getAllTopLevelCategories/productcategory',
                });
                if (response.status === 'success') {
                    setCategories(response.data);
                }
            } catch (err) {
                console.error('Error fetching product categories:', err);
            }
        };
        fetchCategories();
    }, []);

    if (categories.length === 0 && !loading) return null;

    const expandedHeight = categories.length * ITEM_HEIGHT + 16; // +16 for padding

    return (
        <div className='mt-2 mx-2'>
            <div className='px-6 bg-white rounded-xl'>
                <div
                    className='flex items-center justify-between py-3 cursor-pointer'
                    onClick={() => setIsExpanded(prev => !prev)}
                >
                    <BringzzText tag='h4'>{t('component.search.product_categories.title') || 'Product Categories'}</BringzzText>
                    {isExpanded
                        ? <BringzzIcon icon="IconMinu" folder="LineIcons" size="16" />
                        : <BringzzIcon icon="IconPlus" folder="LineIcons" size="16" />
                    }
                </div>
                <div
                    className='transition-all duration-300 ease-in-out overflow-hidden border-b'
                    style={{ maxHeight: isExpanded ? `${expandedHeight}px` : '0px' }}
                >
                    {loading ? (
                        <div className="flex items-center justify-center py-4">
                            <BringzzIcon
                                size="24"
                                icon="IconSpinner"
                                folder="LineIcons"
                                className="animate-spin text-magic-lilac"
                            />
                        </div>
                    ) : (
                        categories.map((category, idx) => (
                            <div
                                key={category.categoryUUID}
                                className={classNames(
                                    'flex items-center h-12 justify-between cursor-pointer',
                                    idx !== categories.length - 1 && 'border-b'
                                )}
                                onClick={() => {
                                    navigate(`/search/product-category/${encodeURIComponent(category.categoryUUID)}`);
                                }}
                            >
                                <div className='flex space-x-3 items-center'>
                                    <BringzzIcon size="34" icon="IconPrescriptionDocument" folder="HealthIcons" />
                                    <BringzzText tag='h3' className='font-normal'>{category.category}</BringzzText>
                                </div>
                                <BringzzIcon size="16" icon="IconChevronRight" folder="LineIcons" />
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductCategories;
